export const FULFILLMENT_STATE_NEW = 'new';
export const FULFILLMENT_STATE_SEND_DOCUMENTS = 'send_documents';
export const FULFILLMENT_STATE_SENT_TO_SUPPLIER = 'sent_to_supplier';
export const FULFILLMENT_STATE_WAITING_FOR_SHIPPING = 'waiting_for_shipping';
export const FULFILLMENT_STATE_VERIFY_TRACKING_NUMBER = 'verify_tracking_number';
export const FULFILLMENT_STATE_COMPLETED = 'completed';
export const FULFILLMENT_STATE_REJECTED = 'rejected';
export const FULFILLMENT_STATE_CANCELED = 'canceled';
export const FULFILLMENT_STATE_CANCELLING = 'cancelling';
export const FULFILLMENT_STATE_CSR = 'csr';

export const ORDER_STATE_PROCESSING = 'processing';
export const ORDER_STATE_VERIFY_SEND_TRACKING_NUMBER = 'verify_send_tracking_number';
export const ORDER_STATE_COMPLETED = 'completed';
export const ORDER_STATE_CANCELED = 'canceled';
export const ORDER_STATE_REJECTED = 'rejected';
export const ORDER_STATE_CSR = 'csr';

export const RETAILER_STATE_ORDERED = 'ordered';
export const RETAILER_STATE_CANCELED = 'canceled';

export const AdditionalOrderStatuses = {
  awaiting_fulfillment: { state: 'Awaiting Fulfillment', hoverInfo: 'Pending Fulfillment or Cancellation' },
  fulfillment_in_progress: {
    state: 'Fulfillment In Progress',
    hoverInfo: 'Fulfillment started, but some items weren’t yet handled (shipped or rejected)',
  },
  fulfilled_partially: {
    state: 'Fulfilled (Partially)',
    hoverInfo: 'All items were handled - some shipped and some shorted',
  },
  fulfilled: { state: 'Fulfilled', hoverInfo: 'Full order was fulfilled' },
  canceled: { state: 'Canceled', hoverInfo: 'Order was canceled' },
  return_in_progress: { state: 'Return In Progress', hoverInfo: 'A return issued on items from this order' }, //TODO: post shipment hovers - TBD
  order_refunded: { state: 'Full Refund', hoverInfo: 'A full refund was issued for this order' },
  partial_refund: { state: 'Partial Refund', hoverInfo: 'A Partial refund was issued for this order' },
  'partial_refund_&_disputed': {
    state: 'Partial Refund & Disputed',
    hoverInfo: 'Some of the items were refunded (refunds accepted) and some disputed',
  },
  refund_disputed: { state: 'Refund Disputed', hoverInfo: 'All items refunds were disputed' },
  expired: { state: 'Expired', hoverInfo: 'Order fulfillment has not been received' },
  late: { state: 'Late Shipping', hoverInfo: 'Based on the SLA defined' },
  csr: { state: 'CSR', hoverInfo: 'There was an issue with the order, Cymbio’s team is on it' },
  manually: { state: 'Manually', hoverInfo: 'Cymbio’s support team has manually handled this order' },
};
